import { PricingModelEnum } from "../models/enums/pricingModel.enum";

export const PRICING_MODEL = [
  {
    id: PricingModelEnum.CPP,
    name: 'global.pricingModels.cpp',
    shortName: 'global.pricingModelsShort.cpp'
  },
  {
    id: PricingModelEnum.CPV,
    name: 'global.pricingModels.cpv',
    shortName: 'global.pricingModelsShort.cpv'
  },
  {
    id: PricingModelEnum.FP,
    name: 'global.pricingModels.fp',
    shortName: 'global.pricingModelsShort.fp'
  }
]